import React, { lazy } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Grid, Card, Text, useMantineTheme, Group, SimpleGrid, Divider, Avatar, Box, Menu, ActionIcon, ThemeIcon, Badge } from '@mantine/core';
import { IconGripVertical, IconUser, IconMessage, IconFileDescription } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";
import { getObjectParam2, stringDivider } from "../../utils/globalFunctions";

const FeedbackDrawer = lazy(() => import('../home/feedback/FeedbackDrawer'));
const SetTeknisiPesanDrawer = lazy(() => import('../../components/utilities/SetTeknisiPesanDrawer'));

export function SortableItem(props) {

  const theme = useMantineTheme();

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.id });

  const [data, setData] = React.useState({
    feedbackModal: false,
    setTeknisiModal: false
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    paddingLeft: '.75rem',
    paddingRight: '.75rem',
    backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
    marginBottom: '.5rem',
    borderRadius: '5px',
    border: `1px solid ${theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[6]}`
  };

  return (
    <>
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'start',
            justifyContent: 'space-between',
            paddingBottom: '.35rem',
            marginBottom: '.25rem',
            borderBottom: `1px solid ${theme.colorScheme === 'light' ? '#ccc' : theme.colors.dark[4]}`
          }}
        >
          <div
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              alignItems: 'start',
              gap: '.75rem',
            }}
          >
            <ThemeIcon
              mt='.2rem'
              variant="light"
              radius="xl"
              size='md'

              style={{
                backgroundColor: theme.fn.rgba((theme.colorScheme === 'light' ? getObjectParam2(utils.priority, String(props.priority), 'colorBgLight', theme.colors.gray[1]) : getObjectParam2(utils.priority, String(props.priority), 'colorBgDark', theme.colors.dark[5])), 0.6),
                color: '#fff'
              }}
            >
              <Text size='xs'>
                {Number(props.num) + 1}
              </Text>
            </ThemeIcon>

            <Box>
              <Text
                size='sm'
                lineClamp={1}
                fw={500}
              >
                {props.name}
              </Text>

              <div
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  wordBreak: 'break-word',
                  gap: '.25rem',
                }}
              >
                <Text
                  size='xs'
                  color='dimmed'
                  style={{ wordBreak: 'keep-all' }}
                >
                  {stringDivider(props.id, [4, 6, 8], '.', '[Nomor Nota]')}
                </Text>

                <Text size='xs' color='dimmed'>-</Text>

                <Text
                  size='xs'
                  color='dimmed'
                  lineClamp={1}
                >
                  {getObjectParam2(utils.projectProcess, props.projectStep, 'caption', ' - ')}
                </Text>
              </div>
            </Box>
          </div>

          <ActionIcon
            size='md'
            variant='transparent'
            radius='xl'

            style={{
              cursor: 'pointer',
              marginRight: '.5rem'
            }}

            {...listeners}
            onTouchStartCapture={(e) => props.fnDragPointTouched(e)}
            onTouchEnd={(e) => props.fnDragPointUntouched(e)}
          >
            <IconGripVertical size='1rem' />
          </ActionIcon>
        </div>

        <div style={{ paddingBottom: '.35rem' }}>
          <Text
            size='sm'
            style={{ wordBreak: 'break-word' }}
            lineClamp={2}
          >
            {props.barangNama ? props.barangNama : '[Barang]'}
          </Text>

          <Text
            size='sm'
            color='dimmed'
            style={{ wordBreak: 'break-word' }}
            lineClamp={2}
          >
            {props.barangKeluhan ? props.barangKeluhan : '[Keluhan]'}
          </Text>
        </div>

        <div
          style={{
            marginTop: '.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '.75rem',
            justifyContent: 'space-between'
          }}
        >
          <Badge
            size='md'
            variant='light'
            color='green'
            styles={{
              root: {
                fontWeight: 'normal',
                textTransform: 'none',
                letterSpacing: '0',
                cursor: 'pointer'
              }
            }}

            onClick={() => {
              setData(d => ({ ...d, feedbackModal: true }))
            }}
          >
            <div
              style={{
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <IconMessage size='12px' stroke={1.75} />
            </div>
          </Badge>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '1rem'
            }}
          >
            <Badge
              size='md'
              variant='light'
              color='grape'
              styles={{
                root: {
                  fontWeight: 'normal',
                  textTransform: 'none',
                  letterSpacing: '0',
                  cursor: 'pointer'
                }
              }}

              onClick={() => setData(d => ({ ...d, setTeknisiModal: true }))}
            >
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                <IconUser size='13px' stroke={1.35} />
              </div>
            </Badge>

            <Badge
              size='md'
              variant='light'
              color='red'
              radius='xl'

              styles={{
                root: {
                  fontWeight: 'normal',
                  textTransform: 'none',
                  letterSpacing: '0',
                }
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  alignItems: 'center',
                }}
              >
                <IconFileDescription size='13px' stroke={1.35} />
              </div>
            </Badge>
          </div>
        </div>
      </div>

      <FeedbackDrawer
        stateShow={data.feedbackModal}
        fnShow={(val) => setData(d => ({ ...d, feedbackModal: val }))}
        stateData={{
          data: props.stateData
        }}
        fnShouldUpdateIndex={() => { }}
      />

      <SetTeknisiPesanDrawer
        stateShow={data.setTeknisiModal}
        fnShow={() => setData(d => ({ ...d, setTeknisiModal: false }))}

        stateData={{
          projectId: props.id,
          projectStep: props.projectStep
        }}

        fnSuccess={props.fnSuccessSetTeknisi}
      />
    </>
  );
}